export default function mergeClasses<T>(className: string, props: T) {
    const cls = (props as any)["className"];
    if (!cls) return { ...props, className };
    return { ...props, className: className + " " + cls } as T;
}
